module.exports = __webpack_public_path__ + "img/my-things.6fb22207.jpg";